<template>
    <div>
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">{{ $t('auto.stringFormatterRegexPattern') }}</div>
            <TiptapEditor
                placeholder="Regular expression pattern"
                :show-attributes="true"
                v-model="clone.regex.pattern"
                :show-emoji="false"
                automation-mode
            />
            <small class="description">{{ $t('auto.stringFormatterRegexEnterTheRegularExpressionPatternToMatch') }}</small>
        </div>

        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">{{ $t('auto.stringFormatterRegexFlags') }}</div>
            <TiptapEditor
                placeholder="Regular expression flags (e.g. 'g' for global, 'i' for case insensitive)"
                :show-attributes="true"
                v-model="clone.regex.flags"
                :show-emoji="false"
                automation-mode
            />
            <small class="description">{{ $t('auto.stringFormatterRegexOptionalRegexFlagsGGlobalICaseInsensitiveMMultilineEtc') }}</small>
        </div>

        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">{{ $t('auto.stringFormatterRegexReplacementText') }}</div>
            <TiptapEditor
                placeholder="Replacement text (only for regex replace operations)"
                :show-attributes="true"
                v-model="clone.regex.replace"
                :show-emoji="false"
                automation-mode
            />
            <small class="description">{{ $t('auto.stringFormatterRegexReplaceMatchedTextWithThisValueLeaveEmptyToJustExtractMatches') }}</small>
        </div>

        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">{{ $t('auto.stringFormatterRegexMatchAllOccurrences') }}</div>
            <a-switch v-model="clone.regex.matchAll" />
            <small class="description">{{ $t('auto.stringFormatterRegexWhenEnabledReturnsAllMatchesAsAnArrayInsteadOfJustTheFirstMatch') }}</small>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";

const log = log2("StringFormatterRegex");
export default {
    name: "StringFormatterRegex",
    components: { TiptapEditor },
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            mode: "string.regex",
            value: "",
            regex: {
                pattern: "",
                flags: "",
                matchAll: false,
                replace: "",
            }
        };
        return {
            clone,
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
        value(newValue) {
            if (_.isEqual(newValue, this.clone)) return;
            this.clone = _.cloneDeep(newValue);
        },
    },
};
</script>

<style lang="scss" scoped>
.editor-row {
    width: 100%;

    &.customize-editor-minimize {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    small.description {
        font-size: 10px;
        color: var(--color-text-weak-default);
    }

    .editor-row-title {
        font-weight: bold;
        font-size: 16px;
    }
}
</style> 